import './global.css';

import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';

import '@core/styles/tailwind.css';

import { Toaster } from '@shared/components/toaster';

import { AppUpdateNotifier } from '@features/app-update';
import { useSeasonalCssVariables } from '@features/seasonal-theme';

import { routes } from '@app/providers/router/routes';

const router = createBrowserRouter(routes);

export const App = () => {
  useSeasonalCssVariables();

  return (
    <>
      <Toaster />
      <AppUpdateNotifier />
      <RouterProvider router={router} />
    </>
  );
};
